export const downloadURL = (url: string) => {
  if (window.median?.share?.downloadFile) {
    window.median.share.downloadFile({
      url,
      open: true,
    });
  } else {
    window.open(url, '_blank');
  }
};
